import { createSlice } from "@reduxjs/toolkit"

import { logout } from "../../containers/LoginPage/redux/auth.thunks.ts"
import { notificationCountsSliceName } from "./notification-counts.constants.ts"
import {
  calendarNotificationsCleared,
  fetchNotificationCounts,
  projectNotificationsCleared
} from "./notification-counts.thunks.ts"
import type { NotificationCountsState } from "./notification-counts.types.ts"

const initialState: NotificationCountsState = {
  projects: 0,
  projectItems: [],
  calendar: 0,
  calendarItems: [],
  approvals: {
    proposals: 0,
    proposalItems: [],
    contracts: 0,
    contractItems: [],
    documents: 0,
    total: 0
  },
  requestId: null,
  status: "idle"
}

const notificationCountsSlice = createSlice({
  name: notificationCountsSliceName,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logout.fulfilled, () => initialState)
      .addCase(fetchNotificationCounts.pending, (state, action) => {
        state.status = "loading"
        state.requestId = action.meta.requestId
      })
      .addCase(fetchNotificationCounts.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) return
        state.status = "succeeded"
        state.requestId = null
        state.projects = action.payload.projects
        state.projectItems = action.payload.projectItems
        state.calendar = action.payload.calendar
        state.calendarItems = action.payload.calendarItems
        state.approvals = action.payload.approvals
      })
      .addCase(fetchNotificationCounts.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) return
        state.status = "failed"
        state.requestId = null
      })
      .addCase(projectNotificationsCleared, (state) => {
        state.projects = 0
        state.projectItems = []
      })
      .addCase(calendarNotificationsCleared, (state) => {
        state.calendar = 0
        state.calendarItems = []
      })
  }
})

export default notificationCountsSlice
